import { render, staticRenderFns } from "./Flop.vue?vue&type=template&id=4e314868&scoped=true&"
import script from "./Flop.vue?vue&type=script&lang=js&"
export * from "./Flop.vue?vue&type=script&lang=js&"
import style0 from "./Flop.vue?vue&type=style&index=0&id=4e314868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e314868",
  null
  
)

export default component.exports